import React from "react";
import { MaskedText, EventButton } from "../common";
import { getDeliveryStatusText } from "../../../utils/newyear/formatters";

const InfoCompleteScreen = ({
  winnerInfo,
  onEdit,
  canEdit = false,
  remainingModifications = 0,
}) => {
  if (!winnerInfo) return null;

  const { name, phone, deliveryStatus, submittedAt } = winnerInfo;

  return (
    <div className="newyear-info-complete">
      <div className="newyear-info-complete__icon">
        <span className="newyear-info-complete__emoji">
          &#10004;
        </span>
      </div>

      <h2 className="newyear-info-complete__title">정보 입력 완료</h2>
      <p className="newyear-info-complete__message">
        당첨자 정보가 성공적으로 제출되었습니다.
      </p>

      <div className="newyear-info-complete__info">
        <div className="newyear-info-complete__row">
          <span className="newyear-info-complete__label">이름</span>
          <span className="newyear-info-complete__value">
            <MaskedText value={name} type="name" />
          </span>
        </div>

        <div className="newyear-info-complete__row">
          <span className="newyear-info-complete__label">연락처</span>
          <span className="newyear-info-complete__value">
            <MaskedText value={phone} type="phone" />
          </span>
        </div>

        {submittedAt && (
          <div className="newyear-info-complete__row">
            <span className="newyear-info-complete__label">제출일시</span>
            <span className="newyear-info-complete__value">
              {new Date(submittedAt).toLocaleString("ko-KR")}
            </span>
          </div>
        )}

        {deliveryStatus && (
          <div className="newyear-info-complete__row">
            <span className="newyear-info-complete__label">발송 상태</span>
            <span className={`newyear-info-complete__delivery-status newyear-info-complete__delivery-status--${deliveryStatus.toLowerCase()}`}>
              {getDeliveryStatusText(deliveryStatus)}
            </span>
          </div>
        )}
      </div>

      {canEdit && remainingModifications > 0 && (
        <div className="newyear-info-complete__actions">
          <p className="newyear-info-complete__edit-notice">
            정보 수정이 필요하신가요? (남은 수정 횟수: {remainingModifications}회)
          </p>
          <EventButton
            variant="secondary"
            size="medium"
            onClick={onEdit}
          >
            정보 수정하기
          </EventButton>
        </div>
      )}
    </div>
  );
};

export default InfoCompleteScreen;
